<div class="flex align-center flex-end">
  <span class="p-r-md" *ngIf="isLarge">{{
    progressPercentage | percent: '1.0-2'
  }}</span>

  <div id="bar" [ngClass]="{ 'bar--long': isLarge }">
    <div #progress id="progress"></div>
  </div>
</div>
